export const GoogleMapApiOptions = {
    libraries: ['places', 'geometry', 'drawing', 'visualization'],
    v: 'weekly'
};
